// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PROFILE_SET_PROFILE,
} from './constants';

export function setProfile(payload) {
  return {
    type: PROFILE_SET_PROFILE,
    data: payload
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_SET_PROFILE:
      let nextState = Object.assign({}, state, {
        user: action.data, 
        uuid: action.data.id
      })
      return {
        ...nextState,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/setProfile.js